import { useEffect, useState } from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { publicOrgService } from '@/services/publicOrg';

const spinner = (
  <div className="flex min-h-[200px] items-center justify-center">
    <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-gray-900 dark:border-white" />
  </div>
);

/**
 * Redirects legacy /club/:slug/* URLs to /club-academy/:orgSlug/*.
 */
export function LegacyClubToOrgRedirect() {
  const location = useLocation();
  const { slug: clubSlug, '*': rest } = useParams<{ slug: string; '*': string }>();
  const [orgSlug, setOrgSlug] = useState<string | null | undefined>(undefined);

  useEffect(() => {
    if (!clubSlug) {
      return undefined;
    }
    let mounted = true;
    void publicOrgService.resolveOrgSlugFromClubSlug(clubSlug).then((resolved) => {
      if (mounted) setOrgSlug(resolved);
    });
    return () => {
      mounted = false;
    };
  }, [clubSlug]);

  if (!clubSlug) {
    return (
      <div className="mx-auto max-w-lg px-4 py-16 text-center">
        <h1 className="text-xl font-semibold">Club not found</h1>
      </div>
    );
  }

  if (orgSlug === undefined) return spinner;
  if (!orgSlug) {
    return (
      <div className="mx-auto max-w-lg px-4 py-16 text-center">
        <h1 className="text-xl font-semibold">Club not found</h1>
      </div>
    );
  }

  const suffix = rest ? `/${rest}` : '';
  return (
    <Navigate
      to={`/club-academy/${orgSlug}${suffix}${location.search}${location.hash}`}
      replace
    />
  );
}
